import React from 'react';
import { Helmet } from 'react-helmet';

const commonKeywords = [
  'Algorithms',
  'Social media',
  'Confirmation bias',
  'Amygdyla',
  'Disinformation',
  'Misinformation',
  'Media bias',
  'Bots',
  'Polarization',
  'Fact check',
  'Sensationalism',
  'Emotional triggers',
  'Tribalism',
  'Information overload',
  'Social media algorithm',
  'News aggregator',
  'Informed citizen',
  'Verified information',
  'Quantified self',
  'News consumption',
  'Amygdyla hijack',
  'Fake news',
];

export const LoginMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};

export const SignUpMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};

export const BlogsMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};

export const HelpMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};

export const HomeNewsMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};

export const HomeReviewMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};

export const HomeAnalyticsMetaTags = () => {
  const keywords = [...commonKeywords];

  return (
    <Helmet>
      <meta name="keywords" content={keywords.join(', ')} />
    </Helmet>
  );
};
